export const DELETE_SPACE = 'organization/space/DELETE'
export const DELETE_SPACE_SUCCESS = `${DELETE_SPACE}_SUCCESS`
